import { Spin } from 'antd';
import { CandlestickChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  categories: string[];
  data: Array<[number, number, number, number]>;
}

function CandlestickWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'candlestick', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <CandlestickChart categories={data?.categories ?? []} data={data?.data ?? []} />;
}

export const candlestickWidgetDef: WidgetDefinition = {
  type: 'candlestick',
  name: 'Candlestick Chart',
  description: 'Financial OHLC data',
  icon: 'StockOutlined',
  category: 'chart',
  defaultTitle: 'Candlestick',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: CandlestickWidget,
  settingsSchema: { fields: [] },
};
